module.exports = __webpack_public_path__ + "img/whyusvneed.37899c38.png";